import { Box, Grid, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';

import Competencies from '../../../../packages/common/shared-ui/src/components/Competencies/Competencies';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import CommonPage from '../../CommonPage/CommonPage';

import CompetencyGrades from './components/CompetencyGrades';

// Original class: userTabs
const StyledUserTabs = styled(Tabs)(theme => ({
  '&.MuiTabs-root': {
    minHeight: 'auto',
  },

  '& .MuiButtonBase-root.MuiTab-root': {
    color: '#656985',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400',
    padding: '8px 16px',
    textTransform: 'capitalize',
    borderRadius: '16px 0 0 16px',
    backgroundColor: '#DCDFF4',
    minHeight: 'auto',
    minWidth: '79px',
    '& + .MuiButtonBase-root.MuiTab-root': {
      borderRadius: '0',
      marginLeft: '2px',
    },
    '& + .MuiButtonBase-root.MuiTab-root + .MuiButtonBase-root.MuiTab-root': {
      borderRadius: '0 16px 16px 0',
      marginLeft: '2px',
    },

    '&.Mui-selected': {
      backgroundColor: '#6270D0',
      color: '#fff',
    },
  },
}));

const Competency = () => {
  const getLocalString = useTranslation();
  const TabsNames = { COMPETENCY: 0, GRADES: 1 };
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(TabsNames.COMPETENCY);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div role='tabpanel' {...other}>
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  return (
    <CommonPage component={'AdminCompetency'} loading={loading}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <Grid>
          <StyledUserTabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            slotProps={{
              indicator: { sx: { display: 'none' } },
            }}
          >
            <Tab
              label={getLocalString('AdminCompetency', 'labels', 'competency')}
            />
            <Tab
              sx={{
                borderRadius: '0 16px 16px 0 !important',
                marginLeft: '2px !important',
              }}
              label={getLocalString('AdminCompetency', 'labels', 'grades')}
            />
          </StyledUserTabs>
        </Grid>
      </Grid>
      <CustomTabPanel value={activeTab} index={0}>
        <Competencies componentMode={'edit'}></Competencies>
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <CompetencyGrades></CompetencyGrades>
      </CustomTabPanel>
    </CommonPage>
  );
};

export default Competency;
